import { WebPlugin } from '@capacitor/core';
export class SunmiPrinterWeb extends WebPlugin {
    SetLeftMargin() {
        throw this.unimplemented('Not implemented on web.');
    }
    SetPrintingAreaWidth() {
        throw this.unimplemented('Not implemented on web.');
    }
    bindService() {
        throw this.unimplemented('Not implemented on web.');
    }
    cutPaper() {
        throw this.unimplemented('Not implemented on web.');
    }
    getCutPaperTimes() {
        throw this.unimplemented('Not implemented on web.');
    }
    getDeviceName() {
        throw this.unimplemented('Not implemented on web.');
    }
    getDrawerStatus() {
        throw this.unimplemented('Not implemented on web.');
    }
    getFontName() {
        throw this.unimplemented('Not implemented on web.');
    }
    getForcedDouble() {
        throw this.unimplemented('Not implemented on web.');
    }
    getForcedRowHeight() {
        throw this.unimplemented('Not implemented on web.');
    }
    getOpenDrawerTimes() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrintedLength() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterBBMDistance() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterDensity() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterMode() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterModel() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterPaper() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterSerialNo() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPrinterVersion() {
        throw this.unimplemented('Not implemented on web.');
    }
    getServiceStatus() {
        throw this.unimplemented('Not implemented on web.');
    }
    getServiceVersion() {
        throw this.unimplemented('Not implemented on web.');
    }
    isForcedAntiWhite() {
        throw this.unimplemented('Not implemented on web.');
    }
    isForcedBold() {
        throw this.unimplemented('Not implemented on web.');
    }
    isForcedUnderline() {
        throw this.unimplemented('Not implemented on web.');
    }
    isLabelMode() {
        throw this.unimplemented('Not implemented on web.');
    }
    labelLocate() {
        throw this.unimplemented('Not implemented on web.');
    }
    labelOutput() {
        throw this.unimplemented('Not implemented on web.');
    }
    lineWrap() {
        throw this.unimplemented('Not implemented on web.');
    }
    openDrawer() {
        throw this.unimplemented('Not implemented on web.');
    }
    print2DCode() {
        throw this.unimplemented('Not implemented on web.');
    }
    printBarCode() {
        throw this.unimplemented('Not implemented on web.');
    }
    printBitmap() {
        throw this.unimplemented('Not implemented on web.');
    }
    printBitmapCustom() {
        throw this.unimplemented('Not implemented on web.');
    }
    printColumnsString() {
        throw this.unimplemented('Not implemented on web.');
    }
    printColumnsText() {
        throw this.unimplemented('Not implemented on web.');
    }
    printOriginalText() {
        throw this.unimplemented('Not implemented on web.');
    }
    printQRCode() {
        throw this.unimplemented('Not implemented on web.');
    }
    printText() {
        throw this.unimplemented('Not implemented on web.');
    }
    printTextWithFont() {
        throw this.unimplemented('Not implemented on web.');
    }
    printerInit() {
        throw this.unimplemented('Not implemented on web.');
    }
    printerSelfChecking() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDAsciiBitmap() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDBarcode() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDBase64Bitmap() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDClearCommand() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDCommand() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDDoubleString() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDFillString() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDHibernateCommand() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDInitializationCommand() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDMultiString() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDString() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendLCDWakeUpCommand() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendRAWBase64Data() {
        throw this.unimplemented('Not implemented on web.');
    }
    sendRAWData() {
        throw this.unimplemented('Not implemented on web.');
    }
    setAbsolutePositionPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setAlignment() {
        throw this.unimplemented('Not implemented on web.');
    }
    setAntiWhitePrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setBold() {
        throw this.unimplemented('Not implemented on web.');
    }
    setBoldPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setDoubleHeightPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setDoubleWidthPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setFontName() {
        throw this.unimplemented('Not implemented on web.');
    }
    setFontSize() {
        throw this.unimplemented('Not implemented on web.');
    }
    setInvertPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setItalicPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setLeftSpacingPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setLineSpacingPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setPrinterStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setRelativePositionPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setStrikethroughPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setStrikethroughStylePrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setTextRightSpacingPrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    setUnderlinePrintStyle() {
        throw this.unimplemented('Not implemented on web.');
    }
    unBindService() {
        throw this.unimplemented('Not implemented on web.');
    }
    updatePrinterState() {
        throw this.unimplemented('Not implemented on web.');
    }
    commitPrinterBuffer() {
        throw this.unimplemented('Not implemented on web.');
    }
    commitPrinterBufferWithCallback() {
        throw this.unimplemented('Not implemented on web.');
    }
    enterPrinterBuffer() {
        throw this.unimplemented('Not implemented on web.');
    }
    exitPrinterBuffer() {
        throw this.unimplemented('Not implemented on web.');
    }
    exitPrinterBufferWithCallback() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map